export default __webpack_public_path__ + "static/media/184.d6bec37b.png";